import { Col, Row, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BellSvg, SettingsSvg } from 'utils/svgs';
import UserNameBox from '../UserNameBox';
import styles from './index.module.scss';
import './index.scss';
import { jwtDecode } from 'jwt-decode';
import { postApi } from 'apis';
import UserProfileModal from 'components/Profile';

const Header = () => {
	const navigate = useNavigate();
	const [formattedDate, setFormattedDate] = useState("");
	const [greeting, setGreeting] = useState("Good Morning");
	const [companies, setCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
	const [isProfileModalOpen, setProfileModalOpen] = useState<boolean>(false);

	const { data: userData } = useSelector((state: any) => state?.userProfile);

	useEffect(() => {
		// Format the date
		const formatDate = () => {
			const options: Intl.DateTimeFormatOptions = {
				weekday: "long",
				day: "numeric",
				month: "long",
				year: "numeric",
			};
			return new Date().toLocaleDateString("en-GB", options);
		};

		// Determine greeting based on the current time
		const getGreeting = () => {
			const hour = new Date().getHours();
			if (hour < 12) return "Good Morning";
			if (hour < 18) return "Good Afternoon";
			return "Good Evening";
		};

		setFormattedDate(formatDate());
		setGreeting(getGreeting());
	}, []);

	useEffect(() => {
		if (userData && userData.companies.length > 0) {
			setCompanies(userData.companies);
			const tokenData: {
				id: string;
				email: string;
				companyId: string;
			} = jwtDecode(localStorage.getItem('accessToken') as string);
			setSelectedCompany(tokenData.companyId);
		}
	}, [userData]);

	const handleNavigatePermissionWise = (currentPath: string) => {
		const targetPath = currentPath.includes('settings') ? '/' : '/settings';
		navigate(targetPath);
	};

	// const logoutHandler = async () => {

	// 	// call logout api
	// 	localStorage.removeItem('userData');
	// 	navigate('/login');
	// };

	const companyHandler = async (id: string) => {
		try {
			const company = await postApi('/company', {
				companyId: id,
			});
			localStorage.setItem('accessToken', company.data.accessToken);
			setSelectedCompany(id);
			window.location.reload();
		} catch (err) {
			console.log('ERRR: ', err);
		}
	};

	const profileCancel = () => {
		setProfileModalOpen(false);
	};

	return (
		<>
			<header className={styles['header']}>
				<Row className={styles['header__wrapper']} align={'middle'} justify={'space-between'}>
					<Col className={styles['header__details-left']}>
						<div className={styles['header__details-left--text']}>
							<p>{greeting}, {userData?.firstName || "Guest"}!</p>
							<p className={styles['header__details-left--text__subtext']}> Today: <span style={{ color: "#949494" }}>{formattedDate}</span></p>
						</div>
					</Col>

					<Col className={styles["header__details-right"]}>
						{companies?.length > 1 && (
							<Select
								placeholder="Select Organization"
								className={
									styles[
									'header__details-right--organization'
									]
								}
								value={selectedCompany}
								onChange={(id: string) => companyHandler(id)}
								disabled={companies?.length == 1}
							>
								{companies?.map((company: any, key: number) => (
									<Select.Option
										value={company?.id}
										key={key}
									>
										{company?.name}
									</Select.Option>
								))}
							</Select>
						)}
						<div className={styles["header__details-right--icons"]}>
							<button className={styles["navButton"]}>
								<BellSvg />
							</button>
							<button className={styles["navButton"]}
								onClick={() => { handleNavigatePermissionWise(window.location.pathname) }}>
								<SettingsSvg />
							</button>
						</div>

						<div className={styles["header__details-right--divider"]}></div>

						<div className={styles["header__details-right--user"]} onClick={() => setProfileModalOpen(true)}>
							<div className={styles["header__details-right--user-logo"]} >
								<UserNameBox name={`${userData?.firstName} ${userData?.lastName}`} />
							</div>
							<div className={styles["header__details-right--user-details"]}>
								<p className={styles["header__details-right--user-name"]}>
									{userData?.firstName || "Guest"}
								</p>
								<p className={styles["header__details-right--user-profile"]}>
									{userData?.roleName || "Employee"}
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</header>
			{isProfileModalOpen && (
				<UserProfileModal
					isProfileModalOpen={isProfileModalOpen}
					handleCancel={profileCancel}
				/>
			)}
		</>
	);
};

export default Header;
